module.exports = __webpack_public_path__ + "media/bg.2abe85b9.mp4";